module.exports = __webpack_public_path__ + "05_short_gray.ee9e01fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/05_short_gray.png
// module id = /OH3
// module chunks = 0